import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ViewRoutingModule } from './view-routing.module';
import { ViewPageComponent } from './pages/view-page/view-page.component';
import { ViewColumnComponent } from './components/view-column/view-column/view-column.component';
import { ViewDrawerComponent } from './components/view-drawer/view-drawer.component';
import { MaterialModule } from '../material.module';
import { ButtonsModule } from '../shared/components/buttons/buttons.module';
import { TreeModule } from '../shared/components/tree/tree.module';
import { NgxsModule } from '@ngxs/store';
import { ViewState } from './state/view.state';
import { ViewMenuComponent } from './components/view-menu/view-menu.component';
import { ViewToolsComponent } from './components/view-tools/view-tools.component';
import { ViewDescriptionComponent } from './components/view-description/view-description.component';
import { PipesModule } from '../shared/pipes/pipes.module';
import { EngineModule } from '../engine/engine.module';
import { IconModule } from '../shared/components/icon/icon.module';
import { ViewToolbarComponent } from './components/view-toolbar/view-toolbar.component';
import { ViewMediaBarComponent } from './components/view-media-bar/view-media-bar.component';
import { DirectivesModule } from '../shared/directives/directives.module';
import { ProgressIndictatorsModule } from '../shared/components/progress-indicators/progress-indicators.module';
import { ViewSearchComponent } from './components/view-search/view-search.component';
import { ViewHelpComponent } from './components/view-help/view-help.component';
import { ViewChaptersComponent } from './components/view-chapters/view-chapters.component';
import { NodeActionsModule } from '../shared/components/node-actions/node-actions.module';
import { ViewNodeDescriptionComponent } from './components/view-node-description/view-node-description.component';
import { ViewLoaderComponent } from './components/view-loader/view-loader.component';
import { ViewScrubberComponent } from './components/view-scrubber/view-scrubber.component';
import { ViewLogoComponent } from './components/view-logo/view-logo.component';
import { ViewPanelComponent } from './components/view-panel/view-panel.component';
import { ViewLabelsComponent } from './components/view-labels/view-labels.component';
import { ViewContentModeComponent } from './components/view-content-mode/view-content-mode.component';
import { ViewHtmlComponent } from './components/view-html/view-html.component';
import { ViewAudioComponent } from './components/view-audio/view-audio.component';
import { ViewScenePaginationComponent } from './components/view-scene-pagination/view-scene-pagination.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { PlayLoaderComponent } from './components/view-loader/play-loader/play-loader.component';
import { ViewLabelDescriptionComponent } from './components/view-label-description/view-label-description.component';
import { ViewColumnContainerComponent } from './components/view-column/view-column-container/view-column-container.component';
import { HandLoaderComponent } from './components/view-loader/hand-loader/hand-loader.component';
import { ButtonLoaderComponent } from './components/view-loader/button-loader/button-loader.component';
import { PillboxModule } from '../shared/components/pillbox/pillbox.module';
import { ViewNavbarComponent } from './components/view-navbar/view-navbar.component';
import { ViewInternalHeaderComponent } from './components/view-internal-header/view-internal-header.component';
import { BookmarksModule } from '../bookmarks/bookmarks.module';
import { ViewColumnToggleComponent } from './components/view-column-toggle/view-column-toggle.component';
import { ViewPrintComponent } from './components/view-print/view-print.component';

@NgModule({
  declarations: [
    ViewPageComponent,
    ViewColumnComponent,
    ViewDrawerComponent,
    ViewMenuComponent,
    ViewToolsComponent,
    ViewDescriptionComponent,
    ViewToolbarComponent,
    ViewMediaBarComponent,
    ViewSearchComponent,
    ViewHelpComponent,
    ViewChaptersComponent,
    ViewNodeDescriptionComponent,
    ViewLoaderComponent,
    ViewScrubberComponent,
    ViewLogoComponent,
    ViewPanelComponent,
    ViewLabelsComponent,
    ViewContentModeComponent,
    ViewHtmlComponent,
    ViewAudioComponent,
    ViewScenePaginationComponent,
    PlayLoaderComponent,
    ViewColumnContainerComponent,
    HandLoaderComponent,
    ButtonLoaderComponent,
    ViewLabelDescriptionComponent,
    ViewColumnContainerComponent,
    ViewNavbarComponent,
    ViewInternalHeaderComponent,
    ViewColumnToggleComponent,
    ViewPrintComponent
  ],
  imports: [
    NgxsModule.forFeature([ViewState]),
    CommonModule,
    EngineModule,

    ViewRoutingModule,
    MaterialModule,

    ButtonsModule,
    DirectivesModule,
    IconModule,
    PipesModule,
    PillboxModule,
    TreeModule,
    ProgressIndictatorsModule,
    NodeActionsModule,
    LazyLoadImageModule,
    BookmarksModule
  ],
  exports: [ViewPageComponent]
})
export class ViewModule { }
